<template>
  <div class="wrapper">
    <menu-ver type="company" name="Company" />
    <div class="container m-3">
      <div class="table-header">
        <button
          class="btn button buttonCreate"
          data-bs-toggle="modal"
          data-bs-target="#addModal"
          @click="getActions(0)"
           :style="{ backgroundColor: colorCompany }" 
        >
          <i class="fas fa-plus-circle"></i> {{ $t("actions.create") }}
        </button>
      </div>

      <table class="table" v-if="departments && departments.length > 0">
        <thead>
          <tr>
            <th scope="col">{{ $t("mCompany.departments.name") }}</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in departments" :key="item.depa_id">
            <td>{{ item.depa_nombre }}</td>
            <td>
              <button
                class="btn button buttonDelete ms-2"
                @click="getActions(2, item)"
                data-bs-toggle="modal"
                data-bs-target="#deleteModal"
              >
                <i class="fas fa-trash"></i>
              </button>
              <button
                class="btn button buttonEdit"                
                @click="getActions(1, item)"
                data-bs-toggle="modal"
                data-bs-target="#editModal"
                :style="{ backgroundColor: colorCompany }" 
              >
                <i class="fas fa-edit"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <p v-else>{{ $t("errors.3") }}</p>
    </div>
  </div>

  <!-- Modal add -->
  <div
    class="modal fade"
    id="addModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            {{
              $t("mCompany.departments.addTitle", { name: `${departmentId}` })
            }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="px-4 py-3">
            <div class="mb-3">
              <label class="form-label">{{$t(`mCompany.departments.name`) + ' *'}}</label>
              <input
                style="text-transform: uppercase"
                type="text"
                class="form-control"
                id="FormName"
                v-model.trim="depa_nombre"
                :placeholder="$t(`mCompany.departments.name`) + '*'"
                maxlength="255"
              />
            </div>
            <span
              v-if="formError"
              class="text-danger"
              style="float: right; font-size: 12px"
              >{{ $t("errors.fieldOb") }}</span
            >
            <span v-else style="float: right; font-size: 12px">{{
              $t("errors.comment")
            }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button
            id="btnSend"
            type="submit"
            class="btn-light btnCrud"
            @click="addDepartment"
             :style="{ backgroundColor: colorCompany }" 
          >
            {{ $t("actions.send") }}
          </button>
          <button
            id="btnClean"
            type="button"
            class="btn-light btnCrud"
            data-bs-dismiss="modal"
            @click="cleanForms()"
          >
            {{ $t("maintenance.actions.cancel") }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal delete -->
  <div
    class="modal fade"
    id="deleteModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            {{
              $t("mCompany.departments.deleteTitle", {
                name: `${departmentId}`,
              })
            }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          {{ $t("mCompany.departments.deleteMessage") }}
        </div>
        <div class="modal-footer" style="justify-content: center">
          <button
            id="btnDelete"
            type="button"
            class="btn-light btnCrud"
            data-bs-dismiss="modal"
            data-bs-toggle="modal"
            data-bs-target="#responseModal"
            @click="deleteDepartment"
          >
            {{ $t("maintenance.actions.confirm") }}
          </button>
          <button
            id="btnClean"
            type="button"
            class="btn-light btnCrud"
            data-bs-dismiss="modal"
          >
            {{ $t("maintenance.actions.cancel") }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal edit -->
  <div
    class="modal fade"
    id="editModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            {{
              $t("mCompany.departments.editTitle", { name: `${departmentId}` })
            }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="px-4 py-3">
            <div class="mb-3">
              <label class="form-label"
                >{{ $t("mCompany.departments.name") }}*</label
              >
              <input
                type="text"
                class="form-control"
                id="exampleDropdownFormName"
                v-model.trim="depa_nombre"
                style="text-transform: uppercase"
                maxlength="255"
              />
            </div>
            <div class="mb-3">
              <label class="form-label">Visible&nbsp;&nbsp;&nbsp;</label>
              <input
                class="form-check-input"
                type="checkbox"
                v-model="isDepaVisible"
                id="flexCheckDefault"
                style="
                  height: 39px;
                  width: 38px;
                  margin-top: -4px;
                  margin-right: 5px;
                "
              />
            </div>

            <span
              v-if="formError"
              class="text-danger"
              style="float: right; font-size: 12px"
              >{{ $t("errors.fieldOb") }}</span
            >
            <span v-else style="float: right; font-size: 12px">{{
              $t("errors.comment")
            }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button
            id="btnSend"
            type="submit"
            class="btn-light btnCrud"
            @click="editDepartment"
             :style="{ backgroundColor: colorCompany }" 
          >
            {{ $t("actions.send") }}
          </button>
          <button
            id="btnClean"
            type="button"
            class="btn-light btnCrud"
            data-bs-dismiss="modal"
            @click="cleanForms()"
          >
            {{ $t("maintenance.actions.cancel") }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal response -->
  <div
    class="modal fade"
    id="responseModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            {{ $t("errors.title") }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="px-4 py-3" style="text-align: center">
            <div v-if="loading" class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <div v-else>
              <div class="modal-body" v-if="result === '0'">
                {{ $t("errors.0") }}
              </div>
              <div class="modal-body" v-else-if="result === '1'">
                {{ $t("errors.1") }}
              </div>
              <div class="modal-body" v-else-if="result === '2'">
                {{ $t("errors.2") }}
              </div>
              <div class="modal-body" v-else-if="result === '3'">
                {{ $t("errors.3") }}
              </div>
              <div class="modal-body" v-else-if="action === 2">
                {{ $t("errors.6") }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer" v-if="!loading">
          <button
            v-if="result === '0' || action === 2"
            type="button"
            class="btn button btn-return-result"
            data-bs-dismiss="modal"
            @click="cleanForms()"
          >
            {{ $t("actions.close") }}
          </button>
          <button
            v-if="action === 0 && result !== '0'"
            class="btn button btn-return-result"
            data-bs-target="#addModal"
            data-bs-toggle="modal"
            data-bs-dismiss="modal"
          >
            {{ $t("actions.return") }}
          </button>
          <button
            v-if="action === 1 && result !== '0'"
            class="btn button btn-return-result"
            data-bs-target="#editModal"
            data-bs-toggle="modal"
            data-bs-dismiss="modal"
          >
            {{ $t("actions.return") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuVer from "../../../components/MenuVer";
import axios from "axios";
import { mapMutations, mapState } from 'vuex';

export default {
  components: {
    MenuVer,
  },
  data() {
    return {
      departments: [],
      department: {
        depa_id: "",
        depa_nombre: "",
        depa_visible: 1
      },
      depa_nombre: "",
      isDepaVisible:false,
      departmentId: "",
      result: "",
      action: 0,
      id: "",
      formError: false,
      loading: false,
    };
  },
  created() {
    this.getDepartments();
    this.changeBreadCrumb(13); 
    this.bigDrop();
    // this.changeIdEmp();
  },
  computed: {
    ...mapState(["colorCompany","servidor"]),
  },
  methods: {
    ...mapMutations(["changeBreadCrumb", "bigDrop"]),
    async getDepartments() {
      try {
        const res = await axios.post(
          `${this.servidor}api/op_emp.asp?tp=depa&ac=listado`
        );
        if (res.data) {
          this.departments = res.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async addDepartment() {
      this.result = "";
      if (this.validateForm()) {
        try {
          this.loading = true;
          const department = {
            depa_nombre: this.depa_nombre.toUpperCase(),
          };
          const res = await axios.post(
            `${this.servidor}api/op_emp.asp?tp=depa&ac=grabar`,
            department
          );
          
          this.result = res.data.RESULT;
          $("#addModal").modal("hide");
          $("#responseModal").modal("show");
        } catch (error) {
          console.error(error);
          this.result = "1";
          $("#addModal").modal("hide");
          $("#responseModal").modal("show");
        }
        this.loading = false;
      }
    },
    async editDepartment() {
      this.result = "";
      if (this.validateForm) {
        try {
          this.loading = true;
          let department = {
            depa_nombre: this.depa_nombre.toUpperCase(),
            depa_id: this.department.depa_id
          };
          if (this.isDepaVisible) {
            department.depa_visible = "1";
          } else {
            department.depa_visible = "0";
          }

          const res = await axios.post(
            `${this.servidor}api/op_emp.asp?tp=depa&ac=actualizar`,
            department
          );
          this.result = res.data.RESULT;
          $("#editModal").modal("hide");
          $("#responseModal").modal("show");
        } catch (error) {
          console.error(error);
          this.result = "1";
          $("#editModal").modal("hide");
          $("#responseModal").modal("show");
        }
        this.loading = false;
      }
    },
    async deleteDepartment() {
      this.result = "";
      try {
        const borrado = {
          depa_id: this.id,
        };
       
        this.loading = true;
        const res = await axios.post(
          `${this.servidor}api/op_emp.asp?tp=depa&ac=borrar`,
          borrado
        );
        this.result = res.data.RESULT;
      } catch (error) {
        console.error(error);
      }
      this.loading = false;
    },
    getId(event) {
      this.departmentId = event[0];
    },
    validateForm() {
      if (this.depa_nombre === "") {
        this.formError = true;
        return false;
      }
      return true;
    },
    cleanForms() {
      this.department = {
        depa_id: "",
        depa_nombre: "",
      };
      this.depa_nombre = "";
      this.isDepaVisible = false;
      this.formError = false;      
      this.loading = false;
      this.getDepartments();
    },
    getActions(act, item) {
      this.action = act;
      if (act === 0) {
        return;
      }
      if (act === 1 && item) {
        this.department = item;
        this.depa_nombre = item.depa_nombre;
        if (this.department.depa_visible === 1) {
          this.isDepaVisible = true;
        } else {
          this.isDepaVisible = false;
        }
        return;
      }
      if (item.depa_id) {
        this.id = item.depa_id;
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  display: flex;
  width: 100%;
  align-items: stretch;
}
.btn {
  float: right;
}
</style>